import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function EditOSDialog({ os, client, onClose, onSaved }) {
  const [device, setDevice] = useState({ ...os.device });
  const [svc, setSvc] = useState({
    reported_issue: os.reportedIssue || "", performed_repair: os.performedRepair || "",
    repair_cost: os.repairCost ?? 0, charged_amount: os.chargedAmount ?? 0,
  });
  const [cli, setCli] = useState({ name: client.name || "", phone: client.phone || "", phone2: client.phone2 || "", email: client.email || "" });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/service-orders/${os.id}`, {
        device, reported_issue: svc.reported_issue, performed_repair: svc.performed_repair,
        repair_cost: parseFloat(svc.repair_cost) || 0, charged_amount: parseFloat(svc.charged_amount) || 0,
      });
      await api.put(`/service-orders/${os.id}/client`, cli);
      toast.success("OS atualizada");
      onSaved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#121217] border-gold/20 text-white max-w-2xl" data-testid="edit-os-dialog">
        <DialogHeader><DialogTitle className="font-display">Editar {os.number}</DialogTitle></DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4 max-h-[60vh] overflow-y-auto pr-1">
          <F label="Cliente"><Input value={cli.name} onChange={(e) => setCli({ ...cli, name: e.target.value })} className="i" /></F>
          <F label="Telefone principal"><Input value={cli.phone} onChange={(e) => setCli({ ...cli, phone: e.target.value })} className="i" /></F>
          <F label="Telefone de recado"><Input value={cli.phone2} onChange={(e) => setCli({ ...cli, phone2: e.target.value })} className="i" /></F>
          <F label="E-mail"><Input value={cli.email} onChange={(e) => setCli({ ...cli, email: e.target.value })} className="i" /></F>
          <F label="Marca"><Input value={device.brand || ""} onChange={(e) => setDevice({ ...device, brand: e.target.value })} className="i" /></F>
          <F label="Modelo"><Input value={device.model || ""} onChange={(e) => setDevice({ ...device, model: e.target.value })} className="i" /></F>
          <F label="Cor"><Input value={device.color || ""} onChange={(e) => setDevice({ ...device, color: e.target.value })} className="i" /></F>
          <F label="IMEI"><Input value={device.imei || ""} onChange={(e) => setDevice({ ...device, imei: e.target.value.replace(/\D/g, "").slice(0, 15) })} className="i" /></F>
          <div className="sm:col-span-2"><F label="Defeito relatado"><Textarea value={svc.reported_issue} onChange={(e) => setSvc({ ...svc, reported_issue: e.target.value })} className="i" rows={2} /></F></div>
          <div className="sm:col-span-2"><F label="Reparo efetuado"><Textarea data-testid="edit-repair" value={svc.performed_repair} onChange={(e) => setSvc({ ...svc, performed_repair: e.target.value })} className="i" rows={2} /></F></div>
          <F label="Custo do reparo (R$)"><Input type="number" value={svc.repair_cost} onChange={(e) => setSvc({ ...svc, repair_cost: e.target.value })} className="i" /></F>
          <F label="Valor cobrado (R$)"><Input type="number" value={svc.charged_amount} onChange={(e) => setSvc({ ...svc, charged_amount: e.target.value })} className="i" /></F>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} className="text-zinc-400">Cancelar</Button>
          <Button data-testid="edit-os-save" onClick={save} disabled={saving} className="text-black font-semibold" style={{ background: "linear-gradient(135deg,#F3C64F,#D4AF37 55%,#AA820A)" }}>Salvar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
const F = ({ label, children }) => (<div><Label className="text-xs text-zinc-400 mb-1.5 block">{label}</Label>{children}</div>);
